<template>
  <div>
    <PageHead title="历史查询"></PageHead>
    <div class="roster oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">姓名：</div>
              <a-input
                allowClear
                placeholder="请输入姓名"
                class="w200"
                v-model="queryForm.fullName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.organizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="replaceFields"
              >
              </a-tree-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">职工状态：</div>
              <a-select
                allowClear
                class="w200"
                placeholder="不限"
                v-model="queryForm.positionStatus"
              >
                <a-select-option
                  v-for="item in positionStatusList"
                  :value="item.valuename"
                  :key="item.id"
                >
                  {{ item.keyname }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <blank height="20"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">选择年月：</div>
              <a-select class="w100" v-model="year" @change="initSelectMonth">
                <a-select-option
                  v-for="item in years"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
              <a-select v-model="month" class="w100 ml20">
                <a-select-option
                  v-for="item in months"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button
          @click="showModal(2)"
          type="primary"
          :style="{ marginLeft: '8px' }"
          icon="download"
        >
          批量导出
        </a-button>

        <span class="statistics"> 数据统计： {{ total }} 人 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="personList"
        :loading="loading"
        :row-key="(record) => record.id + num()"
      >
        <span slot="position" slot-scope="text">{{
          getByTypeName(text, positionList)
        }}</span>
        <span slot="time" slot-scope="text">{{ text || 0 }}年</span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id)">
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <a-modal v-model="visible" title="批量导出" @ok="ExportList" width="600px">
      <div class="operating-steps">
        <div class="operating-steps-item">
          <img class="roster-clear-img" src="./img/plaint.svg" alt="" />
          <div class="roster-clear-num">
            请选择导出字段，姓名和身份证号为必选字段，其他字段可以手选
          </div>
        </div>
      </div>
      <div class="operating-checkbox">
        <a-checkbox v-model="checkAll" @change="onCheckAllChange">
          全选
        </a-checkbox>
        <blank height="10"> </blank>
        <a-checkbox-group
          v-model="excelHeader"
          :options="plainOptions"
          @change="excelHeaderonChange"
        >
          <a-checkbox
            v-for="(item, index) in plainOptions"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-modal>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    width: 80,
    align: 'center'
  },
  {
    title: '员工编号',
    dataIndex: 'personalNumber',
    key: 'personalNumber',

    align: 'center'
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    width: 100,
    key: 'fullName'
  },
  {
    title: '所在部门',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '身份证号',
    dataIndex: 'idCardNumber',
    key: 'idCardNumber',
    ellipsis: true
  },
  {
    title: '行政职务',
    dataIndex: 'position',
    key: 'position',
    scopedSlots: { customRender: 'position' },
    ellipsis: true
  },
  {
    title: '总工龄',
    dataIndex: 'totalSystemAge',
    key: 'totalSystemAge',
    scopedSlots: { customRender: 'time' }
  },
  {
    title: '进入本单位时间',
    dataIndex: 'currentOfficeSysTime',
    key: 'currentOfficeSysTime',
    scopedSlots: { customRender: 'currentOfficeSysTime' }
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]
import { getJobList, getTreeList, personnelMangerJobExport } from './api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      visible: false,
      columns,
      selectedRowKeys: [], // 当前选中的项
      queryForm: {},
      year: '',
      month: '',
      yearsModel: null,
      years: [],
      monthsModel: null,
      months: [],
      personList: [], // 人事花名册列表
      excelHeader: [], //导出对应字段value
      excelHeaderKey: [], //导出对应标题label
      checkAll: false,
      treeData: [], // 组织机构树
      replaceFields: {
        key: 'id',
        value: 'id',
        children: 'treeList',
        title: 'organizationName'
      },
      page: 1,
      total: 0,
      size: 10,
      loading: false,
      plainOptions: [
        { label: '序号', value: 'number' },
        { label: '员工编号', value: 'personalNumber' },
        { label: '所在部门', value: 'organizationName' },

        { label: '行政职务', value: 'position' },
        { label: '任现职务时间', value: 'positionTime' },
        { label: '任现职务年限', value: 'positionAge' },

        { label: '职级', value: 'positionLevel' },
        { label: '任现职级时间', value: 'positionLevelTime' },
        { label: '任现职级年限', value: 'positionLevelAge' },

        { label: '首次参加工作时间', value: 'firstWorkTime' },
        { label: '进入民政系统时间', value: 'civilOfficeSysTime' },
        { label: '进入本公司系统时间', value: 'headOfficeSysTime' },
        { label: '本单位工龄', value: 'currentOfficeSysAge' },
        { label: '总工龄', value: 'totalSystemAge' },

        { label: '进入本公司机关时间', value: 'currentOfficeSysTime' },
        { label: '首次签订合同时间', value: 'firstSignContractTime' },
        { label: '首次签订合同类型', value: 'firstContractType' },
        { label: '首次签订合同年限', value: 'firstContractYears' },
        { label: '首次签订到期时间', value: 'firstContractExpirationTime' },

        { label: '续订1合同时间', value: 'secondSignContractTime' },
        { label: '续订1合同类型', value: 'secondContractType' },
        { label: '续订1合同年限', value: 'secondContractYears' },
        { label: '续订1到期时间', value: 'secondContractExpirationTime' },

        { label: '续订2合同时间', value: 'thirdSignContractTime' },
        { label: '续订2合同类型', value: 'thirdContractType' },
        { label: '续订2合同年限', value: 'thirdContractYears' },
        { label: '续订2到期时间', value: 'thirdContractExpirationTime' },

        { label: '性别', value: 'sex' },
        { label: '出生年月', value: 'birthTime' },
        { label: '年龄', value: 'age' },
        { label: '民族', value: 'nation' },
        { label: '健康状况', value: 'healthStatus' },
        { label: '籍贯', value: 'nativePlace' },
        { label: '户口所在地', value: 'registeredResidence' },
        { label: '户口性质', value: 'registeredNature' },
        { label: '出生地', value: 'birthplace' },
        { label: '政治面貌', value: 'politicalType' },
        { label: '入党时间', value: 'joinPartyTime' },
        { label: '技术职称', value: 'technicalTitle' },
        { label: '职称聘任时间', value: 'appointmentTime' },
        { label: '职称获得时间', value: 'acquisitionTime' },
        { label: '在职教育学历', value: 'education' },
        { label: '在职教育学位', value: 'academicDegree' },
        { label: '在职教育专业', value: 'major' },
        { label: '在职教育毕业院校', value: 'graduationSchool' },
        { label: '全日制教育学历', value: 'firstEducation' },
        { label: '全日制教育学位', value: 'firstAcademicDegree' },
        { label: '全日制教育专业', value: 'firstMajor' },
        { label: '全日制教育毕业院校', value: 'firstGraduationSchool' },
        { label: '家庭地址', value: 'homeAddress' },
        { label: '联系电话', value: 'phone' },
        { label: '减员原因', value: 'attritionReason' },
        { label: '减员日期', value: 'attrtionTiem' },
        { label: '减员备注', value: 'attrtionDes' }
      ]
    }
  },
  computed: {
    ...mapState({
      // plainOptions: (state) => state.app.plainOptions, //Excel导出头
      positionList: (state) => state.bytype.positionList, //行政职务
      positionStatusList: (state) => state.bytype.positionStatusList //职工状态
    }),
    allexcelHeader: function () {
      // `this` 指向 vm 实例
      // 全选
      let Header = []
      for (const value of this.plainOptions) {
        Header.push(value.value)
      }
      return Header
    }
  },
  created() {
    this.init()
    this.getByType()
  },
  methods: {
    ...mapActions(['getposition', 'getpositionStatus']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      getTreeList().then((res) => {
        this.treeData = res.data.data
      })
      //职工状态
      this.getpositionStatus()
      //行政职务
      this.getposition()
    },
    num() {
      //随机整数
      return parseInt(Math.random() * 100)
    },
    init() {
      // 获取年月列表
      var myDate = new Date()
      this.year = this.yearsModel = myDate.getFullYear() //获取当前年
      this.month = this.monthsModel = myDate.getMonth() + 1 //获取当前月
      this.initSelectYear(this.yearsModel)
      this.initSelectMonth(this.yearsModel)
      this.load()
    },
    initSelectYear(year) {
      this.years = []
      for (let i = 0; i < 20; i++) {
        this.years.push({ value: year - i, label: year - i + '年' })
      }
    },
    initSelectMonth(years) {
      //选择年分 更改月份列表
      let month = 12
      if (years == this.yearsModel) {
        month = this.monthsModel
      }
      this.months = []
      for (let i = 1; i <= month; i++) {
        this.months.push({ value: i, label: i + '月' })
      }
      this.months.reverse()
    },
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      params.year = this.year
      params.month = this.month
      getJobList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.personList = res.data.data
          this.total = res.data.count
        }
      })
    },
    showModal() {
      this.visible = true
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.excelHeader = this.allexcelHeader
      } else {
        this.excelHeader = []
      }
    },
    excelHeaderonChange() {
      //判断是否全选
      if (this.excelHeader.length == this.allexcelHeader.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    ExportList() {
      // 批量导出
      let Header = []
      for (const value of this.excelHeader) {
        let name = this.getexcelHeaderKey(value)
        Header.push(name.label)
      }
      this.excelHeaderKey = Header
      let params = this.queryForm
      params.excelHeader = 'fullName,idCardNumber,' + this.excelHeader.join(',') // 对应字段
      params.excelHeaderKey = '姓名,身份证号,' + this.excelHeaderKey.join(',') // 标题
      delete params.size
      delete params.page
      // 导出
      personnelMangerJobExport(params).then((response) => {
        this.visible = false

        // resolve(response.data);
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })

        let fileName = '人事花名册查询导出.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    getexcelHeaderKey(value) {
      // 根据excelHeader获取excelHeaderKey
      return this.plainOptions.find((obj) => {
        if (obj.value == value) {
          return obj
        }
      })
    },
    goDetial(id) {
      this.$router.push({
        path: '/PersonnelDetails',
        query: {
          id,
          year: this.year,
          month: this.month
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.year = this.yearsModel
      this.month = this.monthsModel
      this.initSelectMonth(this.yearsModel)
    },

    subMit() {
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.operating-steps {
  color: rgba(230, 247, 255, 1);
  background-color: rgba(230, 247, 255, 1);
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  .roster-clear-img {
    width: 20px;
    height: 20px;
  }
  .roster-clear-num {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  .operating-steps-item {
    // height: 35px;
    line-height: 35px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
  }
}
.operating-checkbox {
  margin: 20px 10px;
  .ant-checkbox-group-item {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/AdvancedQuery.vue